import styled from 'styled-components'

const Input = styled.input`
  margin:10px 10px 10px 10px;
  border-color:lightgrey;
`;

export default Input;
